import axios from "axios";
import { BASE_URL } from "../config";

const headers = () => {
  const token = localStorage.getItem("authentication/token") || localStorage.getItem("auth_token") || localStorage.getItem("token") || "";
  return token ? { Authorization: `Bearer ${token}` } : {};
};
const prefix = `${BASE_URL}/claims/extract-queue`;
export const listExtractClaimsQueue = (params) => axios.get(prefix, { params, headers: headers() });
export const getExtractClaimsQueueItem = (id) => axios.get(`${prefix}/${id}`, { headers: headers() });
export const retryExtractClaimsQueue = (ids) => axios.post(`${prefix}/retry`, { ids }, { headers: headers() });
export const exportExtractClaimsQueue = (params) => axios.get(`${prefix}/export`, { params, headers: headers(), responseType: "blob" });
